export default __webpack_public_path__ + "images/GA.60b310f.png";